import { observer } from 'mobx-react-lite'
import React from 'react'
import ProfilePage from './ProfilePage'
import ClientThread from './ClientThread'
import AuthenticationsPage from '../../../../../ProjectManager/Influencer/AuthenticationsPage'
import CampaignInfluencerSidebarPageRoutes from '../../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerSidebarPageRoutes'

export default observer(function CampaignInfluencerSidebarPage({ auth }){

  return (
    <CampaignInfluencerSidebarPageRoutes
      auth={auth}
      ProfileComponent={ProfilePage}
      ClientThreadComponent={ClientThread}
      AuthenticationComponent={AuthenticationsPage}
      showAuthentication
    />
  )
})
